/// ///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2026 CONQUER INNOVATIONS SP. Z O.O. Global B.V. and its affiliate(s).
// All rights reserved.
//
// This software and other materials contain proprietary information
// controlled by CONQUER INNOVATIONS SP. Z O.O. and are protected by applicable copyright legislation.
// Any use and utilization of this software and other materials and
// disclosure to any third parties is conditional upon having a separate
// agreement with CONQUER INNOVATIONS SP. Z O.O. for the access, use, utilization or disclosure of this
// software. In the absence of such agreement, the use of the software is not
// allowed.
// The creator, author and originator of the code in the current file: Michał Pawłowski
//////////////////////////////////////////////////////////////////////////////////
<template>
  <b-modal
      v-model="isVisible"
      id="package-order-generator-assistant-modal"
      title="Dodawanie zamówienia centralnego"
      title-class="font-18 fw-bold text-primary"
      header-class="bg-light-gray"
      size="xl"
      hide-footer
      body-class="p-0"
      scrollable
  >
    <div class="row g-3">
      <PackageOrderGeneratorAssistant @onCreateSuccess="handleSuccessOrderCreation($event)"
                                      @onCancelOrder="closeModal"/>
    </div>

  </b-modal>
</template>

<script>
import { BModal } from "bootstrap-vue-next";
import PackageOrderGeneratorAssistant from "@/views/PackagesManager/PackageOrderGeneratorAssistant.vue";

export default {
  name: "PackageOrderGeneratorAssistantModal",
  components: {
    PackageOrderGeneratorAssistant,
    BModal
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },

  },
  emits: ["update:showModal", "onSuccessOrderCreation"],
  computed: {
    isVisible: {
      get() {
        return this.showModal;
      },
      set(val) {
        this.$emit("update:showModal", val);
      }
    }
  },
  methods: {
    handleSuccessOrderCreation(createdOrder) {
      this.$emit("onSuccessOrderCreation",createdOrder);
    },
    closeModal(){
      this.isVisible = false;
      this.$emit("onClose")
    }
  }
};
</script>

<style scoped>
.bg-light-gray {
  background-color: #f3f2f1;
}

/* Ustawiamy sztywną wysokość dla kontenera wewnątrz modala */
.manager-wrapper {
  height: 80vh;
  min-height: 500px;
  overflow: hidden;
}
</style>